module.exports = __webpack_public_path__ + "img/indu_13.a5196cb6.png";